import * as React from 'react';
import { memo } from 'react';

const InspectedByRove = () => (
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.2998 7.04565L5.53809 9.92261L12.6797 1.42456"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const Memo = memo(InspectedByRove);
export default Memo;
